import type { Components, CssVarsTheme } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiFormControl']
>['styleOverrides'] = {
  root: ({ theme }) => ({
    minWidth: 150,
    '&:has(.Mui-readOnly)': {
      cursor: 'not-allowed',
      '& .MuiInputLabel-root': {
        cursor: 'not-allowed',
      },
    },
    '&.MuiTextField-root': {
      '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-fullWidth.MuiInputBase-formControl':
        {
          padding: theme.spacing(0.5),
          '& .MuiInputBase-input.MuiOutlinedInput-input': {
            height: '1em',
            padding: theme.spacing(1.75, 1),
          },
        },
      '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-sizeSmall.MuiInputBase-formControl':
        {
          padding: theme.spacing(0.5),
          '& .MuiInputBase-input.MuiOutlinedInput-input': {
            height: '1em',
            padding: theme.spacing(1.1, 1),
          },
        },
      '& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-sizeSmall.MuiInputLabel-outlined':
        {
          lineHeight: 1.5,
        },
    },
  }),
};

const MuiFormControl: Components<CssVarsTheme>['MuiFormControl'] = {
  styleOverrides,
};

export default MuiFormControl;
